import { useLocation, useNavigate } from 'react-router-dom';

export const useNavigatePage = path => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = row => {
    navigate(`${path}/${row.id}${location.search}`);
  };

  return {
    handleNavigate,
  };
};
